export function truncate(value, limit = 20){
    if(value.length > limit){
        return value.substr(0, limit) + " …"
    }
}